var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4386(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#F2411F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H11.9969C11.4469 12 11 12.4531 11 13.0094V24.9906C11 25.5469 11.4469 26 11.9969 26H24C24.55 26 25 25.5469 25 24.9906V13.0094C25 12.4531 24.55 12 24 12ZM15.2312 24H13.1562V17.3187H15.2344V24H15.2312ZM14.1937 16.4062C13.5281 16.4062 12.9906 15.8656 12.9906 15.2031C12.9906 14.5406 13.5281 14 14.1937 14C14.8562 14 15.3969 14.5406 15.3969 15.2031C15.3969 15.8687 14.8594 16.4062 14.1937 16.4062ZM23.0094 24H20.9344V20.75C20.9344 19.975 20.9187 18.9781 19.8562 18.9781C18.775 18.9781 18.6094 19.8219 18.6094 20.6938V24H16.5344V17.3187H18.525V18.2312H18.5531C18.8312 17.7062 19.5094 17.1531 20.5188 17.1531C22.6188 17.1531 23.0094 18.5375 23.0094 20.3375V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4386);
export default __webpack_public_path__ + "static/media/Group 4386.e4ed59e357530f021b7ffc8115eee875.svg";
export { ForwardRef as ReactComponent };